<div class="innerBanner" [style.background-image]="'url(' + genSpecialIntrest.bannerImage + ')'">
  <div class="bannerText">
    <h1 [attr.data-before-content]="beforeHeadingContent">Nature</h1>
  </div>

  <div class="mouse_scroll" (click)="scollBottom()">
    <div class="mouse">
      <div class="wheel"></div>
    </div>
    <div>
      <span class="m_scroll_arrows unu"></span>
      <span class="m_scroll_arrows doi"></span>
      <span class="m_scroll_arrows trei"></span>
    </div>
  </div>
</div>
<div class="container contentPanel">
  <div class="pageTitle mt-5">
    <p [innerHTML]="genSpecialIntrest.bannerContent"></p>
  </div>
  <div class="placesToSee">
    <h1>{{ 'Places To See' | translate }}</h1>
    <p-carousel
      [value]="placesToSeeData"
      styleClass="custom-carousel"
      [numVisible]="4"
      [numScroll]="1"
      [circular]="true"
      [responsiveOptions]="responsiveOptions"
    >
      <ng-template let-product pTemplate="item">
        <div class="product-item">
          <div class="wishlistHeart" (click)="$event.stopPropagation(); addToWhishList(product)">
            <i class="fa fa-heart wishlist" [style.color]="product.color ? product.color : '#fff'"></i>
          </div>
          <a target="_blank" [href]="'/listingdetails/' + product.productId">
            <div class="product-item-content">
              <div class="image parr-image" *ngIf="product.productImage">
                <img [src]="product.productImage" [alt]="product.productImage" class="popular-img" />
              </div>
              <div class="category-title">
                <h4>
                  {{
                    product.productName.length > 30 ? (product.productName | slice: 0:30) + '...' : product.productName
                  }}
                </h4>
                <small *ngIf="product.addresses"
                  ><i class="icon-location"></i>{{ product.addresses[0].islandArea
                  }}<span *ngIf="product.addresses[0].islandArea && product.addresses[0].island">,&nbsp;</span
                  >{{ product.addresses[0].island }}</small
                >
              </div>
            </div>
          </a>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>
<div class="thumbnails" style="background-image: url('../../../assets/images/testimonialBgLarge.avif')">
  <div class="container">
    <div class="whitebg">
      <p-carousel
        [value]="TestMonialData"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
      >
        <ng-template let-product pTemplate="item">
          <div class="product-item thumbnailImage">
            <div class="product-item-content">
              <div class="image" [style.background-image]="''">
                <img [src]="product.uri" [alt]="" class="product-image" stlye="width:100%" />
              </div>
              <div class="category-title">
                <h4><i class="fas fa-quote-left"></i></h4>
                <h4>My Favourite</h4>
                <p>{{ product.body }}</p>
                <div class="userProfile">
                  <h4>
                    {{ product.field_testimonial_name }}
                  </h4>
                  <h6>{{ product.field_testimonial_designation }}</h6>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>

<div class="container contentPanel">
  <div class="placesToSee">
    <h1>{{ 'Things To Do' | translate }}</h1>
    <p-carousel
      [value]="thingsToDoData"
      styleClass="custom-carousel"
      [numVisible]="4"
      [numScroll]="1"
      [circular]="true"
      [responsiveOptions]="responsiveOptions"
    >
      <ng-template let-product pTemplate="item">
        <div class="product-item">
          <div class="wishlistHeart" (click)="$event.stopPropagation(); addToWhishList(product)">
            <i class="fa fa-heart wishlist" [style.color]="product.color ? product.color : '#fff'"></i>
          </div>
          <a target="_blank" [href]="'/listingdetails/' + product.productId">
            <div class="product-item-content">
              <div class="image parr-image" *ngIf="product.productImage">
                <img [src]="product.productImage" [alt]="product.productImage" class="popular-img" />
              </div>
              <div class="category-title">
                <h4>
                  {{
                    product.productName.length > 30 ? (product.productName | slice: 0:30) + '...' : product.productName
                  }}
                </h4>
                <small *ngIf="product.addresses"
                  ><i class="icon-location"></i>{{ product.addresses[0].islandArea
                  }}<span *ngIf="product.addresses[0].islandArea && product.addresses[0].island">,&nbsp;</span
                  >{{ product.addresses[0].island }}</small
                >
              </div>
            </div>
          </a>
        </div>
      </ng-template>
    </p-carousel>
  </div>

  <div class="placesToSee blog">
    <h1 class="text-center">{{ 'Blog' | translate }}</h1>
    <p class="text-center mb-4" style="font-size: 19px; margin-top: -10px">
      {{ 'Articles from Seychelles' | translate }}
    </p>
    <div class="">
      <p-carousel
        [value]="highlightsProducts"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        [ngClass]="lang"
      >
        <ng-template let-product pTemplate="item">
          <a class="product-item slider-arrow" target="_blank" [href]="getBlogUrl(product)">
            <div class="product-item-content">
              <div class="image parr-image" *ngIf="product.uri">
                <img [src]="product.uri" [alt]="product.uri" class="popular-img" />
              </div>
              <div class="title" *ngIf="product.specialInterestName">
                <i class="{{ product.specialIntersetIcon }}"></i>
                <span>{{ product.specialInterestName | translate | uppercase }}</span>
              </div>
            </div>
          </a>
          <a class="text mt-2 aquacolor product-a" target="_blank" [href]="getBlogUrl(product)">
            <p>{{ product.title }}</p>
          </a>
        </ng-template>
      </p-carousel>
      <div class="viewall-btn">
        <a href="/blog">{{ 'View All Articles' | translate }}</a>
      </div>
    </div>
  </div>
</div>
<p-toast position="top-center" key="add-wishlist" [baseZIndex]="15000"></p-toast>
<div class="np-loader" *ngIf="showLoader">
  <p-progressSpinner strokeWidth="5"></p-progressSpinner>
</div>
